import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProfileService } from "../../profile/profile.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LocalStorageService } from "../../shared/local-storage.service";

@Component({
    selector: "app-htl-password-dialog",
    templateUrl: "./htl-password-dialog.component.html",
    styleUrls: ["./htl-password-dialog.component.scss"],
    standalone: false,
})
export class HtlPasswordDialogComponent implements OnInit {
    public passwordFormGroup: FormGroup;
    public editAllowed = false;
    public errorMsg: string;

    constructor(
        private _formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<HtlPasswordDialogComponent>,
        private _profileService: ProfileService,
        private _localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.passwordFormGroup = this._formBuilder.group({
            password: ["", <any>Validators.required],
        });
    }

    ngOnInit(): void {
        if (this.data.allowed) {
            this.editAllowed = true;
        } else {
            this.editAllowed = false;
            this.errorMsg = this.data.message;
        }
    }

    onConfirm() {
        if (this.passwordFormGroup.valid) {
            const username = this._localStorageService.getUserLocalStorageObject().username;
            this._profileService.authorize(username, this.passwordFormGroup.controls["password"].value).subscribe({
                next: (result) => this.dialogRef.close(true),
                error: (error) => this.passwordFormGroup.controls["password"].setErrors({ invalid: true }),
            });
        }
    }

    onCancel() {
        this.dialogRef.close(false);
    }
}
